module.exports = __webpack_public_path__ + "static/media/l_citizencan_logo_noir.b5eea094.png";